<template>
  <div>
    <div style="text-align: right;margin-bottom: 15px">
      <el-button type="primary" :loading="submitLoading" @click="exportExcel">
        导出序列号
      </el-button>
    </div>
    <el-table v-loading="loading" :data="tableData" border style="width: 100%">
      <el-table-column type="index" width="70" label="序号" align="left" />
      <el-table-column prop="buyerName" label="客户名称" align="left" width="300" />
      <el-table-column prop="receivingUnit" label="收货单位" align="left" />
      <el-table-column prop="sellTime" label="出货日期" align="left" />
      <el-table-column prop="productName" label="商品名称" align="left" />
      <el-table-column prop="barcodeNumber" label="序列号" align="left" />
    </el-table>
  </div>
</template>
<script type="es6">
import axios, { getSerialNumberListByContract } from '@/API';
import { formatDate } from '@/libs/util.js';
export default {
  data () {
    return {
      tableData: [],
      loading: false,
      submitLoading: false
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    }
  },
  components: {
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getSerialNumberListByContract(this.strContractCode, '').then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    exportExcel () {
      if (this.tableData.length) {
        this.submitLoading = true;
        axios.get('/export/getExportSerialNumberList?strContractCode=' + this.strContractCode, {
          responseType: 'blob'// 服务器返回的数据类型
        }).then((res) => {
          this.submitLoading = false;
          const content = res.data;
          const blob = new Blob([content]);// 构造一个blob对象来处理数据
          let date = new Date();
          date = formatDate(date, 'yyyy-MM-dd');
          const fileName = '序列号明细' + date + '.xlsx';

          // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
          // IE10以上支持blob但是依然不支持download
          if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
            navigator.msSaveBlob(blob, fileName);
          } else { // 其他浏览器
            const link = document.createElement('a');// 创建a标签
            link.download = fileName;// a标签添加属性
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();// 执行下载
            URL.revokeObjectURL(link.href); // 释放url
            document.body.removeChild(link);// 释放标签
          }
        }).catch(() => {
          this.submitLoading = false;
        });
      } else {
        this.$notify.warning('没有序列号明细不可导出');
        this.submitLoading = false;
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
